import * as React from 'react'

import { Select } from '@workwave-tidal/core/components'

import { useHandlers } from './hooks/useHandlers'
import { EmployeeUserOption, useData } from './hooks'
import { ReferralFormProps } from '@user/components/Referrals/components/UpdateReferral/UpdateReferralForm/UpdateReferralForm'
import FormHelperText from '@mui/material/FormHelperText'

export default function TidalEmployeeSelect(props: ReferralFormProps) {
  const { options, getOptionLabel, initialOption, getId, density } = useData()
  const { handleTidalEmployeeSelectChange, isInValid, error } =
    useHandlers(props)
  return (
    <>
      <Select<EmployeeUserOption>
        getLabel={getOptionLabel}
        getId={getId}
        items={options}
        onChange={handleTidalEmployeeSelectChange}
        value={initialOption}
        label={'Employee'}
        required
        density={density}
        optionMode={'normal'}
        data-test-id="employee-select"
        error={isInValid}
      />
      {isInValid && (
        <FormHelperText sx={{ ml: 1 }} error>
          {error}
        </FormHelperText>
      )}
    </>
  )
}
